import CarouselAutoSlide from "design-system/resources/assets/js/carouselAutoSlide";

export default function getIdCarouselForAutoSlide() {
  const allCarouselsSelector =  document.querySelectorAll('.carousel');

  allCarouselsSelector && allCarouselsSelector.forEach((e)=> {
    var currId = e.getAttribute('id');
    if(currId) {
      CarouselAutoSlide("#" + currId);
    }
  })
}